import React from 'react';
import { Grid } from '@material-ui/core';

import { CompanyShareCourseForm } from 'views/Company/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <CompanyShareCourseForm />
        </Grid>
      </Grid>
    </div>
  );
};
